import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#646F76",
      d: "M14.695 14.694a.75.75 0 0 1 1.06 0l5.026 5.025.051.057a.75.75 0 0 1-1.055 1.055l-.057-.05-5.025-5.026a.75.75 0 0 1 0-1.06"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#646F76",
      d: "M16.444 10.472a5.973 5.973 0 1 0-11.945.002 5.973 5.973 0 0 0 11.945-.002m1.5 0a7.473 7.473 0 1 1-14.946-.001 7.473 7.473 0 0 1 14.946 0"
    }, null, -1)
  ]))]))
}
export default { render: render }